import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
const SocialNewUserHint = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasSeenHint = localStorage.getItem("hasSeenNewUserHint");
    if (!hasSeenHint) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem("hasSeenNewUserHint", "true");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div style={styles.container}>
      <h2>👋 Bienvenue sur Peuple Québec !</h2>
      <p>
        🚧 La plateforme est en pleine construction, alors ne t’inquiète pas si ce n’est pas encore parfait.
        Nous sommes en train de bâtir quelque chose de grand !
      </p>
      <p>
        💰 Découvre la section <strong>Marketing</strong> qui te permet de gagner de l'argent grâce à tes ami(e)s.
      </p>
      <p>
        🎉 Chaque semaine, <strong>50$</strong> sont offerts à l’utilisateur le plus actif ! Alors, reste connecté(e) et participe !
      </p>
      <button style={styles.button} onClick={handleClose}>Ok, j'ai compris !</button>
    </div>
  );
};

const styles = {
  container: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    maxWidth: "300px",
    padding: "15px",
    backgroundColor: "#fff",
    border: "2px solid #007bff",
    borderRadius: "10px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    fontSize: "14px",
    textAlign: "center",
    zIndex: 1000,
  },
  button: {
    marginTop: "10px",
    padding: "8px 12px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
  }
};

export { SocialNewUserHint };
